/**
 * Site-wide imprint, rendered once in App below the routed page so it appears
 * on every view — including the pages that sit outside Layout (login, device
 * setup wizard, mobile setup).
 */
const Imprint = () => (
  <footer className="w-full border-t border-gray-200 bg-white/70 py-3 px-4">
    <p className="text-center text-xs text-gray-500">
      {new Date().getFullYear()} - by Health Stream Analytics, LLC, Seattle, WA, USA
    </p>
  </footer>
);

export default Imprint;
